export const sanitizeYear = (value) => {
    if(value === '')
    {
        return null
    }

    return Math.max(0, Math.min(9999,
        Number(value)
    ))
}
